// Stylised lotus bloom, white shapes on transparent — used as a CSS mask so the
// bright layer of the collage only shows through the flower, and the field
// around it falls into darkness. From afar the images resolve into the lotus.
//
// Built as a fan of ellipses rotated around the base point (500, 780):
// a centre petal and three symmetric pairs, plus a sepal arc at the base.

const petal = (rx, ry, cy, angle) =>
  `<ellipse cx='500' cy='${cy}' rx='${rx}' ry='${ry}' transform='rotate(${angle} 500 780)' fill='white'/>`;

const SHAPES = [
  petal(88, 250, 530, 0), // centre petal
  petal(82, 235, 545, -26), // inner pair
  petal(82, 235, 545, 26),
  petal(74, 215, 575, -52), // mid pair
  petal(74, 215, 575, 52),
  petal(64, 185, 615, -74), // outer pair
  petal(64, 185, 615, 74),
  // base sepals — a shallow cup under the bloom
  "<path d='M240,790 Q500,860 760,790 Q500,930 240,790 Z' fill='white'/>",
];

export const LOTUS_MASK_URL = `url("data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 950'><filter id='soft'><feGaussianBlur stdDeviation='16'/></filter><g filter='url(#soft)'>${SHAPES.join("")}</g></svg>`
)}")`;

// Raw petal geometry, for decorative line-work reuse (ghosted motifs on inner pages)
export const LOTUS_SHAPES = SHAPES;
